module.exports = __webpack_public_path__ + "img/header-mobile-rtmlogo.574fa601.svg";